exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".checkboxes{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/Rsvp.css
// module id = 384
// module chunks = 0